export default [
  { text: "lecture.payment-status.SETTLED", value: "PAID" },
  { text: "lecture.payment-status.NOT_SETTLED", value: "NOT_PAID" },
];
